import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Eye, EyeOff, Check, X } from "lucide-react";

export const PASSWORD_RULES = [
  { key: "len", label: "Mindestens 8 Zeichen", test: (p) => p.length >= 8 },
  { key: "upper", label: "Ein Großbuchstabe", test: (p) => /[A-Z]/.test(p) },
  { key: "lower", label: "Ein Kleinbuchstabe", test: (p) => /[a-z]/.test(p) },
  { key: "digit", label: "Eine Zahl", test: (p) => /\d/.test(p) },
  { key: "special", label: "Ein Sonderzeichen", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export const isPasswordValid = (p) => PASSWORD_RULES.every((r) => r.test(p));

export function PasswordField({ value, onChange, label = "Passwort", testid = "password", showChecklist = true, autoComplete = "new-password" }) {
  const [show, setShow] = useState(false);
  return (
    <div>
      <Label htmlFor={testid} className="text-base font-medium text-stone-800">{label}</Label>
      <div className="relative mt-2">
        <Input id={testid} data-testid={testid} type={show ? "text" : "password"} value={value}
          onChange={(e) => onChange(e.target.value)} autoComplete={autoComplete}
          className="h-14 px-4 pr-12 text-lg rounded-xl" />
        <button type="button" data-testid={`${testid}-toggle`} onClick={() => setShow((s) => !s)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400 hover:text-stone-700">
          {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
        </button>
      </div>
      {showChecklist && (
        <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-1.5" data-testid={`${testid}-checklist`}>
          {PASSWORD_RULES.map((r) => {
            const ok = r.test(value);
            return (
              <li key={r.key} className={`flex items-center gap-2 text-sm ${ok ? "text-emerald-700" : "text-stone-400"}`}>
                {ok ? <Check className="w-4 h-4" /> : <X className="w-4 h-4" />} {r.label}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
